
import React, { useEffect, useState } from 'react'
import { allUsertApi } from '../../../apifile/ApiFiles'

const UserReportFilter = ({ initialValue, onChangeHandle, getCandidatelistDataFilter }) => {
    const [data, setData] = useState(null)
    const combooData = async () => {
        try {
            const res = await allUsertApi()
            // console.log(res?.data);
            setData(res?.data)

        } catch (error) {

        }
    }
    useEffect(() => {
        combooData()
    }, [])

    return (
        <div className="pageBody mb-3">
            <div className="pageTable">
                <form>
                    <div className="row mb-3">
                        <div className="form-group mb-3 col-lg-4 col-md-6">
                            <label htmlFor="language_level">
                                <strong>Start Date</strong>
                            </label>
                            <input
                                className="form-control"
                                placeholder="Name"
                                type="date"
                                value={initialValue.start_date}
                                name="start_date"
                                onChange={onChangeHandle}
                            />
                        </div>
                        <div className="form-group mb-3 col-lg-4 col-md-6">
                            <label htmlFor="language_level">
                                <strong>End Date</strong>
                            </label>
                            <input
                                className="form-control"
                                placeholder="Name"
                                type="date"
                                value={initialValue.end_date}
                                name="end_date"
                                onChange={onChangeHandle}
                            />
                        </div>

                        <div className="form-group mb-3 col-lg-4 col-md-4">
                            <label htmlFor="lang" className="mb-1 ">
                                <strong>User</strong>
                            </label>
                            <select
                                className="form-select"
                                name="user_id"
                                value={initialValue.user_id}
                                onChange={onChangeHandle}
                            >
                                <option selected>Select User</option>
                                {data &&
                                    data?.map((item) => {
                                        return (
                                            <option value={item._id}>{item.firstname} {item.lastname}</option>
                                        );
                                    })}
                            </select>
                        </div>



                        <div className="mb-3 col-lg-12 col-md-4 text-center">
                            <div className="bt_container">
                                <a href="#" type="btn" className="bg-primary report_btn me-2" onClick={() => getCandidatelistDataFilter(0)}>
                                    Search
                                </a>

                                {/* <a href="#" type="btn" className="bg-success report_btn me-2" style={{ margin: "0 7px" }} onClick={resetFnData}>
                                    Reset
                                </a> */}
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default UserReportFilter